<template>
    <b-container class="container-layout mt-5" fluid>
        <b-row align-h="center">
            <b-col lg="4">
                <b-input
                        required
                        placeholder="Nombre de examen"
                        class="simulacro-register"
                        type="text"
                        :state="validateStateSimulacro('nombre')"
                        v-model="$v.formsimulacro.nombre.$model"
                />
            </b-col>
            <b-col lg="2">
                <b-input
                        required
                        placeholder="Tiempo total"
                        class="simulacro-register"
                        type="text"
                        disabled="disabled"
                        :state="validateStateSimulacro('tiempototal')"
                        v-model="$v.formsimulacro.tiempototal.$model"
                />
            </b-col>
            <b-col lg="2">
                <b-input
                        required
                        placeholder="Puntaje total"
                        class="simulacro-register"
                        type="text"
                        disabled="disabled"
                        :state="validateStateSimulacro('puntajetotal')"
                        v-model="$v.formsimulacro.puntajetotal.$model"
                />
            </b-col>
        </b-row>
        <b-row align-h="center">
            <b-col lg="2">
                <p class="title-key mt-3">Puntaje por pregunta</p>
            </b-col>
            <b-col lg="2">
                <b-input
                        required
                        placeholder="Correcta"
                        class="simulacro-register"
                        type="text"
                        :state="validateStateSimulacro('correcta')"
                        v-model="$v.formsimulacro.correcta.$model"
                />
            </b-col>
            <b-col lg="2">
                <b-input
                        required
                        placeholder="Incorrecta"
                        class="simulacro-register"
                        type="text"
                        :state="validateStateSimulacro('incorrecta')"
                        v-model="$v.formsimulacro.incorrecta.$model"
                />
            </b-col>
            <b-col lg="2">
                <b-input
                        required
                        placeholder="En blanco"
                        class="simulacro-register"
                        type="text"
                        :state="validateStateSimulacro('blanco')"
                        v-model="$v.formsimulacro.blanco.$model"
                />
            </b-col>
        </b-row>
        <b-row class="mt-1" align-h="center">
            <p
                    v-if="this.$v.formsimulacro.$anyError"
                    class="error-register mb-n5 mt-2"
            >Faltan Campos por completar del simulacro</p>
        </b-row>
        <b-row align-h="center">
            <b-alert
                    v-model="showDismissibleAlert"
                    dismissible
                    variant="danger"

            >
                {{ mensajeAlert }}
                <br>
                <div v-if="faltante.length > 0" v-for="(error, index) in faltante" :key="index">
                    <span>Modulo: {{ error.titulo }}</span>
                    <br>
                    <p>{{ error.msj }} <span v-if="error.hasOwnProperty('descripcion')"
                                             v-html="error.descripcion"></span></p>
                </div>
            </b-alert>
        </b-row>
        <b-row class="mt-5" align-h="center">
            <b-button class="crear-simulacro" @click="crear()">CREAR</b-button>
        </b-row>
        <b-row class="mt-3" align-h="center">
            <b-col class="mt-3" cols="4">
                <b-card class="mx-auto card-info text-center">
                    <b-card-text @click="AgregarModulo()">
                        <img class="img-modulo" src="@/assets/images/plus.png" alt/>
                        <p class="mt-2 plus-simulacro">Agregar módulo</p>
                        <br/>
                    </b-card-text>
                </b-card>
            </b-col>
            <b-col v-for="(item,key) in modulo" :key="key" class="mt-3" cols="4">
                <b-card
                        :style="index==key ?'background:rgba(15, 55, 110, 0.3)':''"
                        :header="'Modulo '+ (key+1)"
                        header-class="header-info"
                        class="mx-auto card-info text-center"
                >
                    <b-card-text>
                        <p class="info-text">{{item.titulo}}</p>
                        <br/>
                        <b-row align-h="around">
                            <p>
                                <img
                                        style="cursor:pointer"
                                        @click="editar(key)"
                                        class="mr-5"
                                        src="@/assets/images/editinfo.png"
                                        alt
                                />
                                <img
                                        style="cursor:pointer"
                                        @click="eliminarModulo(key)"
                                        class="ml-5"
                                        src="@/assets/images/eraseinfo.png"
                                        alt
                                />
                            </p>
                        </b-row>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="showpreguntas" class="mt-5" align-h="center">
            <b-col cols="9">
                <b-card header-class="header-preguntas" body-class="text-center">
                    <template v-slot:header>
                        <b-row align-h="center" class="titulo-preguntas-2">{{titulo_preguntas}}</b-row>
                    </template>

                    <b-card-text v-for="(items, i) in modulo[index].npreguntas" :key="i">
                        <editor
                                api-key="gesewuu9jwv1p9la48mwzsnrniuxuei3vugq45y6ygffctjq"
                                v-model="modulo[index].preguntas[i]['descripcion']"
                                :init="getTinyConfig"
                        />

                        <b-row
                                class="mt-1 ml-1"
                                v-for="(opt, x) in modulo[index].preguntas[i]['opcion']"
                                :key="x"
                        >
                            <p>
                                <img :src="require(`@/assets/images/${letras[x]}`)" alt/>
                                <span class="option-modal" v-html="opt.opcion"></span>
                            </p>
                        </b-row>
                        <p @click="AgregarOpcion(index, i)" class="plus-simulacro preguntas-plus">
                            <img class="img-plus-preguntas" src="@/assets/images/plus.png" alt/>
                            Agregar respuesta
                        </p>
                        <p class="preguntas"></p>
                    </b-card-text>

                    <b-button @click="emitToParent()" class="cambios">GUARDAR CAMBIOS</b-button>
                </b-card>
            </b-col>
        </b-row>


        <b-modal content-class="modal-carrera" hide-footer ref="modal-modulo" centered size="lg">
            <b-row align-h="center" class="mt-5 examen-finish">
                <p class="fondo-carrera" style="color:#0F376E">AGREGAR MÓDULO</p>
            </b-row>
            <b-row align-h="center" class="mt-n4">
                <b-col lg="9">
                    <b-input
                            required
                            placeholder="Titulo del módulo"
                            class="pl-2 mt-5 simulacro-register"
                            type="text"
                            :state="validateState('titulo')"
                            v-model="$v.form.titulo.$model"
                    />
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col lg="3">
                    <b-input
                            required
                            placeholder="Tiempo estimado"
                            class="pl-2 mt-4 simulacro-register"
                            type="text"
                            :state="validateState('tiempo')"
                            v-model="$v.form.tiempo.$model"
                    />
                </b-col>
                <b-col lg="3">
                    <b-input
                            required
                            placeholder="# de preguntas"
                            class="pl-2 mt-4 simulacro-register"
                            type="text"
                            :state="validateState('npreguntas')"
                            v-model="$v.form.npreguntas.$model"
                    />
                </b-col>
                <b-col lg="3">
                    <b-input
                            required
                            placeholder="Puntaje"
                            class="pl-2 mt-4 simulacro-register"
                            type="text"
                            :state="validateState('puntaje')"
                            v-model="$v.form.puntaje.$model"
                    />
                </b-col>
                <p
                        v-if="this.$v.form.$anyError"
                        class="error-register mb-n5 mt-2"
                >Faltan Campos por completar</p>
            </b-row>

            <b-row align-h="center" class="mb-4 mt-5">
                <button
                        @click="agregar()"
                        style="background:#0F376E!important"
                        class="password-aceptar"
                >AGREGAR
                </button>
            </b-row>
        </b-modal>
        <b-modal
                no-enforce-focus
                content-class="modal-carrera"
                hide-footer
                ref="modal-opcion"
                centered
                size="lg"
        >
            <b-row align-h="center" class="examen-finish">
                <p class="fondo-carrera" style="color:#0F376E">OPCION</p>
            </b-row>
            <b-row align-h="center" class>
                <b-col lg="9">
                    <editor api-key="gesewuu9jwv1p9la48mwzsnrniuxuei3vugq45y6ygffctjq" v-model="opcion" :init="getTinyConfig"/>
                </b-col>
            </b-row>

            <b-row align-h="center" class="mb-4 mt-4">
                <button
                        @click="addOpcion()"
                        style="background:#0F376E!important"
                        class="password-aceptar"
                >ACEPTAR
                </button>
            </b-row>
        </b-modal>
        <b-modal hide-footer ref="modal-examen" centered size="md">
            <b-row align-h="center" class="mt-2">
                <img src="@/assets/images/checkdatos.png" alt/>
            </b-row>

            <b-row align-h="center" class="mt-4">
                <b-col cols="10">
                    <p class="key-sub">Examen creado exitosamente</p>
                </b-col>
            </b-row>
            <b-row align-h="center" class="mt-3">
                <button @click="finish()" class="key-aceptar">ACEPTAR</button>
            </b-row>
        </b-modal>
        <b-row align-h="center">
            <semipolar-spinner
                    v-if="loaded"
                    class="spinner ml-5"
                    :animation-duration="2000"
                    :size="80"
                    color="#0F376E"
            />
        </b-row>
    </b-container>
</template>

<script>
    import Editor from "@tinymce/tinymce-vue";
    import {validationMixin} from "vuelidate";
    import configs from "../../local_config";
    import {SemipolarSpinner} from "epic-spinners";
    import {required, numeric, decimal} from "vuelidate/lib/validators";

    export default {
        name: "NewModulo",
        mixins: [validationMixin],
        components: {Editor, SemipolarSpinner},
        data: () => ({
            dismissSecs: 10,
            dismissCountDown: 0,
            showDismissibleAlert: false,
            mensajeAlert: '',
            loaded: false,
            getTinyConfig: {
                height: 300,
                menubar: true,

                images_upload_url:
                configs.HTTP_API + "//" + configs.API + "/api/imageUpload",
                plugins: [
                    "advlist autolink lists link image charmap print preview anchor",
                    "searchreplace visualblocks code fullscreen",
                    "insertdatetime media table paste code help wordcount"
                ],
                toolbar:
                    "bold italic  | \
                       alignleft aligncenter alignright alignjustify | \
                       bullist"
            },
            showpreguntas: false,
            titulo_preguntas: "",
            modulo: [],
            index: 0,
            configs: configs,
            letras: ["A.png", "B.png", "C.png", "D.png", "E.png"],
            opcion: "",
            moduloopcion: "",
            preguntaopcion: "",
            form: {
                titulo: null,
                puntaje: null,
                npreguntas: null,
                tiempo: null
            },
            key: "",
            colegios: {},
            formsimulacro: {
                nombre: null,
                tiempototal: 0,
                puntajetotal: 0,
                correcta: null,
                incorrecta: null,
                tipo: "P",
                blanco: null
            },
            secciones: [],
            grados: [],
            simulacros: [],
            simulacro: [],

            premedios: [],
            data: [],
            api: configs.API,
            http: configs.HTTP_API,
            faltante: []
        }),
        validations: {
            formsimulacro: {
                nombre: {
                    required
                },
                tiempototal: {
                    required,
                    numeric
                },
                puntajetotal: {
                    required,
                    decimal
                },
                incorrecta: {
                    required,
                    numeric
                },
                blanco: {
                    required,
                    numeric
                },
                correcta: {
                    required,
                    numeric
                }
            },

            form: {
                titulo: {
                    required
                },
                puntaje: {
                    required,
                    decimal
                },
                npreguntas: {
                    required,
                    numeric
                },
                tiempo: {
                    required,
                    numeric
                }
            }
        },
        created() {
            this.$store.dispatch("setModulo", "AGREGAR NUEVO SIMULACRO");
            this.$store.dispatch("setNav", "active");
//    this.$store.dispatch("getCareer").then(response => {
//      this.carreras = response.data.carrera;
//    });
        },
        methods: {
            validateStateSimulacro(name) {
                const {$dirty, $error} = this.$v.formsimulacro[name];
                return $dirty ? !$error : null;
            },
            validateState(name) {
                const {$dirty, $error} = this.$v.form[name];
                return $dirty ? !$error : null;
            },
            agregar() {
                this.$v.form.$touch();
                if (this.$v.form.$anyError) {
                    return;
                }
                this.formsimulacro.puntajetotal =
                    parseFloat(this.formsimulacro.puntajetotal) + parseFloat(this.form.puntaje);
                this.formsimulacro.tiempototal =
                    parseInt(this.formsimulacro.tiempototal) + parseInt(this.form.tiempo);
                this.showpreguntas = false;
                console.log('this.form:', this.form);
                this.modulo.push({
                    titulo: this.form.titulo,
                    puntaje: this.form.puntaje,
                    npreguntas: parseInt(this.form.npreguntas),
                    tiempo: this.form.tiempo,
                    preguntas: new Array(parseInt(this.form.npreguntas))
                });
                console.log('this.modulo:', this.modulo);
                console.log('el indice es :', this.index, this.modulo.length);
                this.index = this.modulo.length - 1
                for (let index = 0; index < this.modulo[this.index].npreguntas; index++) {
                    this.modulo[this.index].preguntas[index] = {
                        descripcion: "<p></p>",
                        opcion: []
                    };
                }

                console.log('this.modulo luego:', this.modulo);

                this.$refs["modal-modulo"].hide();
                this.form = {
                    titulo: null,
                    puntaje: null,
                    npreguntas: null,
                    tiempo: null
                };
                this.index = this.index + 1;
            },
            editar(key) {
                this.index = key;
                this.showpreguntas = true;
                this.titulo_preguntas = this.modulo[key].titulo;
                this.showDismissibleAlert = false;
                this.loaded = true;
                setTimeout(function(scope) {
                    scope.loaded = false;
                }, 3000, this);

            },
            eliminarModulo(key) {
                this.$confirm("Seguro desea eliminar este módulo?", "Módulo", "warning").then(() => {
                    this.modulo.splice(key, 1);
                });

            },
            AgregarModulo() {
                this.showDismissibleAlert = false;
                this.$refs["modal-modulo"].show();
            },
            finish() {
                this.$refs["modal-examen"].hide();
                this.$router.go(-1);
            },
            AgregarOpcion(modulo, pregunta) {
                this.moduloopcion = modulo;
                this.preguntaopcion = pregunta;
                this.$refs["modal-opcion"].show();
            },
            addOpcion() {
                if (this.opcion.trim() !== '') {
                    this.modulo[this.moduloopcion].preguntas[
                        this.preguntaopcion
                        ].opcion.push({opcion: this.opcion});
                    this.opcion = "";
                } else {
                    this.$alert("Debe Agregar una opcion", 'Opción', 'warning');
                }
                this.$refs["modal-opcion"].hide();
            },
            addTag(newTag) {
                const tag = {
                    name: newTag,
                    code: newTag.substring(0, 2) + Math.floor(Math.random() * 10000000)
                };
                this.carrera.push(tag);
                this.carreras.push(tag);
            },
            onChildClick(value) {
                this.data = value;
            },
            crear() {
                this.$v.formsimulacro.$touch();
                if (this.$v.formsimulacro.$anyError) {
                    return;
                }
                if (this.modulo.length === 0) {
//                    this.dismissCountDown = this.dismissSecs
//                    this.showDismissibleAlert = true
//                    this.mensajeAlert = 'Debe Agregar un Modulo antes de crear el Simulacro'
                    this.$alert("Debe Agregar un módulo antes de crear el Simulacro", 'Módulo', 'warning');
                } else {
                    this.faltante = []
                    this.modulo.forEach(function (valor) {
                        valor.preguntas.forEach(function (valor1, index1) {
                            let pregunta = index1 + 1
                            if (valor1.descripcion === '<p></p>') {
                                console.log('pregunta vacia :')
                                this.faltante.push({
                                    titulo: valor.titulo,
                                    msj: 'Falta la Pregunta N# ' + pregunta,
                                })
                            }

                            if (valor1.opcion.length === 0) {
                                console.log('opciones vacias :')
                                this.faltante.push({
                                    titulo: valor.titulo,
                                    msj: 'Falta las opciones de la pregunta N#' + pregunta,
                                    descripcion: valor1.descripcion
                                })
                            }
                        }, this)
                        if (this.faltante.length > 0) {
//                            this.dismissSecs = 30
//                            this.dismissCountDown = this.dismissSecs
                            this.showDismissibleAlert = true
                            this.mensajeAlert = 'Debe Agregar las siguientes opciones:'
                        }
                    }, this)
                    if (this.showDismissibleAlert === false) {
                        this.loaded = true;
                        let data = {
                            modulos: this.modulo,
                            simulacro: this.formsimulacro,
                            tipo: "p"
                        };
                        this.$store
                            .dispatch("postSimulacro", data)
                            .then(response => {
                                this.loaded = false;
                                this.simulacro = response.data.simulacro;
                                this.$refs["modal-examen"].show();
                            })
                            .catch(error => {
                                this.loaded = false;
                                console.log(error.message);
                            });
                    }
                }
            },
            emitToParent() {
                this.$emit("childToParent", this.modulo);
                this.showpreguntas = false;
            },
            countDownChanged(dismissCountDown) {
                this.dismissCountDown = dismissCountDown
            }
        },
        filters: {
            fixed(value) {
                return parseFloat(value).toFixed(0);
            }
        },
        computed: {}
    };
</script>
<style scoped>
</style>